import { productImageResolution, productImageSizes } from "../../image/constants";
import findResolutionIndex from "../../image/findResolutionIndex";
import regexMapGroup from './regexMapGroup';
import { setToHighDpi } from '../constants';
/**
 * This function returns a liquid pixel url that changed to a high DPI image url.
 *
 * @param url - The image url.
 * @returns - Return a url.
 */
const lpUrlToHighDpi = (url) => {
    const resCallRegex = /(?<Res>res\[\S\]).+&(?<Call>call=url\[\S+\])/;
    const resCallMatch = url.match(resCallRegex);
    if (resCallMatch && resCallMatch.groups) {
        const resGroup = resCallMatch.groups.Res;
        const callGroup = resCallMatch.groups.Call;
        const currentResolutionIndex = findResolutionIndex(resGroup, callGroup);
        if (currentResolutionIndex !== undefined &&
            currentResolutionIndex + 1 < productImageSizes.length) {
            const nextResolution = productImageSizes[currentResolutionIndex + 1];
            const [nextRes, nextCall] = productImageResolution[nextResolution];
            const newUrl = url.replace(resGroup, nextRes).replace(callGroup, nextCall);
            return newUrl;
        }
        return url;
    }
    const sizeRegex = /scale=size\[(?<Size>\d+)\]/;
    return regexMapGroup(url, sizeRegex, 'Size', setToHighDpi);
};
export default lpUrlToHighDpi;
//# sourceMappingURL=lpUrlToHighDpi.js.map